
export default {
  namespaced: true,
  state: () => ({
    policyString: null,
    parsedRule: null
  }),
  mutations: {
    setPolicyString (state, policyString) {
      state.policyString = policyString
      try {
        state.parsedRule = JSON.parse(policyString)
      } catch {
        state.parsedRule = null
      }
    },
    setParsedRule (state, parsedRule) {
      state.policyString = JSON.stringify(parsedRule, {}, 2)
      state.parsedRule = parsedRule
    },
    purge (state) {
      state.policyString = null
      state.parsedRule = null
    }
  },
}